/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getWebLoginConfig} from '../api'

 export const useQueryGetWebLoginConfig = createReactQueryHook('getWebLoginConfig', getWebLoginConfig)
